export default "__VITE_ASSET__849f9b72__"